import { gql } from '@apollo/client';

export const GET_EARN_POINTS_INFO = gql`
  query GetEarnPointsInfo {
    profile {
      controlVisitDateRange {
        fromDays
        toDays
      }
      groupLECodeForFirstFitting
    }
    earnPointsInfo {
      appointments {
        availability {
          controlVisitAvailability
          annualEyeCheckAvailability
        }
        availableDates {
          appointmentType
          startDate
          endDate
          eligibilityDate
          maxEndDate
        }
      }
    }
    rewardList {
      name
      points
      expire
    }
  }
`;
